<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Free Register</h5>
                  <p>Get your HESLB account now.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img alt="" class="img-fluid" src="assets/images/profile-img.png">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <a routerLink="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img alt="" class="rounded-circle" height="34" src="assets/images/logo.png">
                  </span>
                </div>
              </a>
            </div>
            <div class="p-2">

              <form (ngSubmit)="onSubmit(advancedSearchForm.value)" [formGroup]="advancedSearchForm" class="needs-validation"
                    name="signupForm"
                    novalidate>
                <ng-container>
                  <div class="mb-3">
                    <label class="form-label" for="benefIndexNo">Form 4 Index Number</label>

                    <input [ngClass]="{ 'is-invalid': (f.benefIndexNo.dirty || f.benefIndexNo.touched) && f.benefIndexNo.errors }" class="form-control" formControlName="benefIndexNo"
                           id="benefIndexNo"
                           placeholder="Enter Form 4 Index Number"
                           type="text"/>
                    <div *ngIf="(f.benefIndexNo.dirty || f.benefIndexNo.touched) && f.benefIndexNo.errors"
                         class="invalid-feedback">
                      <div *ngIf="f.benefIndexNo?.errors?.required">Index Number is required</div>
                      <div *ngIf="f.benefIndexNo?.errors?.isValidIndexNo">Please Enter A Valid Index Number</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="firstName">First Name</label>

                    <input [ngClass]="{ 'is-invalid': (f.firstName.dirty || f.firstName.touched) && f.firstName.errors }" class="form-control" formControlName="firstName"
                           id="firstName"
                           placeholder="Enter Your First Name"
                           type="text"/>
                    <div *ngIf="(f.firstName.dirty || f.firstName.touched) && f.firstName.errors"
                         class="invalid-feedback">
                      <div *ngIf="f.firstName?.errors?.required">Fist Name is required</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="middleName">Middle Name</label>

                    <input [ngClass]="{ 'is-invalid': (f.middleName.dirty || f.middleName.touched) && f.middleName.errors }" class="form-control" formControlName="middleName"
                           id="middleName"
                           placeholder="Enter Your Middle Names"
                           type="text"/>
                    <div *ngIf="(f.middleName.dirty || f.middleName.touched) && f.middleName.errors"
                         class="invalid-feedback">
                      <div *ngIf="f.middleName?.errors?.required">Middle Name is required</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="lastName">Last Name</label>

                    <input [ngClass]="{ 'is-invalid': (f.lastName.dirty || f.lastName.touched) && f.lastName.errors }" class="form-control" formControlName="lastName"
                           id="lastName"
                           placeholder="Enter Your Last Name"
                           type="text"/>
                    <div *ngIf="(f.lastName.dirty || f.lastName.touched) && f.lastName.errors" class="invalid-feedback">
                      <div *ngIf="f.lastName?.errors?.required">Last Name is required</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="col-form-label" for="sex">Gender</label>

                    <select [ngClass]="{ 'is-invalid': (f.sex.dirty || f.sex.touched ) && f.sex.errors }" class="form-select" formControlName="sex"
                            id="sex"
                    >
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </select>
                    <div *ngIf="(f.sex.dirty || f.sex.touched) && f.sex.errors" class="invalid-feedback">
                      <div *ngIf="f.sex?.errors?.required">Please Select Your Gender.</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="university">Univeristy Of Study</label>
                    <ng-select
                      [clearable]="true"
                      [ngClass]="{ 'is-invalid': (f.university.dirty || f.university.touched) && f.university.errors }"
                      [searchable]="true"
                      formControlName="university"
                      id="university"
                      placeholder="Select Your University Of Study">
                      <ng-option *ngFor="let item of institutions"
                                 [value]="item?.institution_name">
                        {{item.institution_name}}({{item?.institution_code}})
                      </ng-option>
                    </ng-select>
                    <div *ngIf="(f.university.dirty || f.university.touched) && f.university.errors"
                         class="invalid-feedback">
                      <div *ngIf="f.lastName?.errors?.required">Your University Of Study Is Required</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="startYear">Univeristy Start Year</label>

                    <input [ngClass]="{ 'is-invalid': (f.startYear.dirty || f.startYear.touched) && f.startYear.errors }" class="form-control" formControlName="startYear"
                           id="startYear"
                           placeholder="Enter Your University Start Year"
                           type="number"/>
                    <div *ngIf="(f.startYear.dirty || f.startYear.touched) && f.startYear.errors"
                         class="invalid-feedback">
                      <div *ngIf="f.startYear?.errors?.required">Your University Start Year Is Required</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="startYear">University Completion Year</label>

                    <input [ngClass]="{ 'is-invalid': (f.completionYear.dirty || f.completionYear.touched) && f.completionYear.errors }" class="form-control" formControlName="completionYear"
                           id="completionYear"
                           placeholder="Enter Your Univerity Completion"
                           type="number"/>
                    <div *ngIf="(f.completionYear.dirty || f.completionYear.touched) && f.completionYear.errors"
                         class="invalid-feedback">
                      <div *ngIf="f.completionYear?.errors?.required">Your University Completion Year Is Required</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="email">Email</label>

                    <input [ngClass]="{ 'is-invalid': (f.email.dirty || f.email.touched) && f.email.errors }" class="form-control" formControlName="email"
                           id="email" placeholder="Email"
                           type="email"/>

                    <div *ngIf="(f.email.dirty || f.email.touched) && f.email.errors" class="invalid-feedback">
                      <div *ngIf="f.email?.errors?.required">Your Current Email is required</div>
                      <div *ngIf="f.email?.errors?.email">Email must be a valid email address</div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="form-label" for="phone">Phone Number</label>

                    <input [ngClass]="{ 'is-invalid': (f.phone.dirty || f.phone.touched) && f.phone.errors }" class="form-control" formControlName="phone"
                           id="phone" placeholder="Phone Number"
                           type="text"/>
                    <div *ngIf="(f.phone.dirty || f.phone.touched) && f.phone.errors" class="invalid-feedback">
                      <div *ngIf="f.phone?.errors?.required">Your Current Phone Number Is Required</div>
                      <div *ngIf="f.phone?.errors?.isValidPhoneNumber">A Valid Tz Phone Number Is Required</div>
                    </div>
                  </div>

                </ng-container>

                <div class="mt-4 d-grid">
                  <button [disabled]="advancedSearchForm.invalid" [ladda]="loadingSubmit"
                          class="btn btn-primary" type="submit">Submit
                  </button>
                  <div *ngIf="savedAdvancedSearchDetails" class="row text-center p-1"><span class="text-success">Your Advanced Search Is Being Processed Use The Reference Number: <span
                    class="fw-bolder text-warning">{{savedAdvancedSearchDetails?.reference_number}}</span> </span></div>
                  <!--                  <button class="btn btn-primary" type="submit">Register</button>-->
                </div>
                <div class="mt-4 text-center">
                  <p class="mb-0">By registering you agree to the HESLB <a class="text-primary"
                                                                           href="javascript: void(0);">Terms of
                    Use</a></p>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>Already have an account ? <a class="fw-medium text-primary" routerLink="/account/login"> Login</a>
          <p>Do You Have A Reference Number ? <a class="fw-medium text-primary"
                                                 routerLink="/account/benef-advanced-search-progress"> Search Progress</a>
          </p>
          <p>© {{year}} HESLB.</p>
        </div>
      </div> <!-- end col -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</div>
